<!-- eslint-disable vue/no-ref-as-operand -->
<template>
  <div class="headerContent" style="margin-top: 20px !important; display: flex; align-items: center; gap: 88px; cursor: pointer">
    <span class="mainPageTitle">{{ selectedTenantUsesTextract ? t('documentTraining.titleTextract') : t('documentTraining.titleBedrock') }}</span>
  </div>
  <div class="headerContent" style="margin-top: 20px !important; display: flex; align-items: center; gap: 8px; cursor: pointer">
    <div class="createUserHeader">
      <svg @click="goBack" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <path d="M5.25 11.25H20.25C20.45 11.25 20.64 11.33 20.78 11.47C20.92 11.61 21 11.8 21 12C21 12.2 20.92 12.39 20.78 12.53C20.64 12.67 20.45 12.75 20.25 12.75H5.25C5.05 12.75 4.86 12.67 4.72 12.53C4.58 12.39 4.5 12.2 4.5 12C4.5 11.8 4.58 11.61 4.72 11.47C4.86 11.33 5.05 11.25 5.25 11.25Z" fill="black" />
        <path d="M5.56 12L11.78 18.22C11.92 18.36 12 18.55 12 18.75C12 18.95 11.92 19.14 11.78 19.28C11.64 19.42 11.45 19.5 11.25 19.5C11.05 19.5 10.86 19.42 10.72 19.28L3.97 12.53C3.9 12.46 3.84 12.38 3.81 12.29C3.77 12.2 3.75 12.1 3.75 12C3.75 11.9 3.77 11.8 3.81 11.71C3.84 11.62 3.9 11.54 3.97 11.47L10.72 4.72C10.86 4.58 11.05 4.5 11.25 4.5C11.45 4.5 11.64 4.58 11.78 4.72C11.92 4.86 12 5.05 12 5.25C12 5.45 11.92 5.64 11.78 5.78L5.56 12Z" fill="black" />
      </svg>
      <span class="newPageTitle" v-if="isEditFlow && editableDisplayName">{{ isEditFlow ? t('documentTraining.editDocumentType') : t('documentTraining.addDocumentType') }} : {{ editableDisplayName }}</span>
      <span class="newPageTitle" v-else-if="isEditFlow && isLoadingEditData">{{ t('documentTraining.loadingDocumentType') }}</span>
      <span class="newPageTitle" v-else-if="route.query.displayName">{{ t('documentTraining.documentTypeName') }} : {{ decodeURIComponent(route.query.displayName) }}</span>
      <span class="newPageTitle" v-else-if="isEditFlow && blueprintName">{{ isEditFlow ? t('documentTraining.editDocumentType') : t('documentTraining.addDocumentType') }} : {{ blueprintName }}</span>
      <span class="newPageTitle" v-else-if="step === 'upload'">{{ isEditFlow ? t('documentTraining.editDocumentType') : t('documentTraining.addNewDocumentType') }}</span>
      <span class="newPageTitle" v-else-if="step === 'preview'">{{ t('documentTraining.documentPreview') }}</span>
      <span class="newPageTitle" v-else-if="step === 'fieldMapping'">{{ isEditFlow ? t('documentTraining.edit') : t('documentTraining.configure') }} {{ t('documentTraining.extractionFields') }}</span>
      <span class="newPageTitle" v-else-if="step === 'allset'">{{ isEditFlow ? t('documentTraining.update') : t('documentTraining.configure') }} {{ t('documentTraining.settings') }}</span>
    </div>
  </div>
  <!-- Global loading spinner -->
  <div v-if="isLoading" style="position: absolute; top: 50%; left: 65%; transform: translate(-50%, -50%); display: flex; justify-content: center; align-items: center">
    <div class="spinner-border text-primary spinner-grow-xl" roleCategories="status"></div>
  </div>
  <AppLayout v-else :showMarquee="step === 'completion'" active="dashboard">
    <template #title>
      <span v-if="step === 'upload'">{{ selectedTenantUsesTextract ? t('documentTraining.titleTextract') : t('documentTraining.titleBedrock') }}</span>
      <div v-if="step === 'preview'" style="display: flex; align-items: center; gap: 8px">
        <button @click="goBack" class="back-button" :aria-label="t('documentTraining.back')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#164863" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <span>{{ selectedTenantUsesTextract ? t('documentTraining.titleTextract') : t('documentTraining.titleBedrock') }}</span>
      </div>
      <span v-if="step === 'fieldMapping'">{{ t('extractionFields.title') }}</span>
      <span v-if="step === 'completion'">{{ t('documentTraining.configureForVasionStorage') }}</span>
    </template>
    <div v-if="step === 'upload'" class="uploads-container">
      <!-- Show loader when uploading file OR when loading edit mode data -->
      <div v-if="fileUploading || isLoadingEditData" class="centered">
        <div class="horizontal-loader">
          <div class="loader-bar"></div>
        </div>
        <div class="loading-message">{{ isLoadingEditData ? $t('uploads.loading_document_data') : messages }}</div>
      </div>
      <template v-else>
        <template v-if="!showExtractionData">
          <div class="upload-card">
            <h2>{{ isEditFlow ? (selectedTenantUsesTextract ? $t('uploads.edit_document_type_training_textract') : $t('uploads.edit_document_type_training_bedrock')) : selectedTenantUsesTextract ? t('documentTraining.trainNewDocumentTypeTextract') : t('documentTraining.trainNewDocumentTypeBedrock') }}</h2>
            <div v-if="!route.query.displayName" class="form-field" style="margin-bottom: 20px">
              <label>{{ t('documentTraining.documentTypeName') }}</label>
              <input type="text" v-model="manualDocumentTypeName" :placeholder="t('documentTraining.enterDocumentTypeName')" autocomplete="off" maxlength="50" @input="handleManualNameInput" />
              <!-- Error message shown only if invalid -->
              <span v-if="!isNameValid && manualDocumentTypeName" class="error-text">
                <strong>{{ $t('uploads.invalid_name_label') }}</strong>
                {{ blueprintNameErrorMessage }}
              </span>
            </div>
            <!-- Textract Analysis Type Dropdown (only for Textract tenants) -->
            <div v-if="selectedTenantUsesTextract && isTextractFlow" class="form-field" style="margin-bottom: 20px">
              <label>{{ t('documentTraining.textractAnalysisType') || 'Analysis Type' }}</label>
              <select v-model="textractAnalysisType" class="form-field-input">
                <option value="">{{ t('documentTraining.selectAnalysisType') || 'Select Analysis Type' }}</option>
                <option value="AnalyzeDocument">Analyze Document (eg. application forms, survey forms)</option>
                <option value="AnalyzeExpense">Analyze Expense (eg. Invoices, receipts)</option>
                <option value="AnalyzeID">Analyze ID (eg. passports, driver licenses)</option>
                <option value="AnalyzeLending">Analyze Lending (eg. mortgage documents)</option>
              </select>
              <span v-if="!textractAnalysisType && showTextractError" class="error-text">
                <strong>{{ $t('uploads.required_field') || 'Required' }}</strong>
                {{ t('documentTraining.analysisTypeRequired') || 'Please select an analysis type' }}
              </span>
            </div>
            <!-- <label class="upload-label">Document Type Name : {{ decodeURIComponent(route.query.displayName) }}</label> -->
            <label class="upload-label">{{ selectedTenantUsesTextract ? t('documentTraining.uploadFileToStartTextract') : t('documentTraining.uploadFileToStartBedrock') }}</label>
            <div class="">
              <!-- <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px">
                <label class="input-label">Select Class</label>
                <button v-if="!editMode && !isCreatingNew" @click="toggleCreateNew" type="button" class="primary-btn create-new-btn">+ Create New</button>
              </div> -->
              <!-- <div class="form-field">
                <div style="display: flex; gap: 8px; align-items: center">
                  <div v-if="classesLoading" class="">Loading classes...</div>
                  <select v-if="!classesLoading && !editMode && !isCreatingNew" v-model="classSelectionMode" @change="onClassSelectionChange" :class="{ 'error-border': showErrors && errors.name }" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px" :disabled="classesLoading">
                    <option value="">{{ classesLoading ? 'Loading classes...' : 'Select Class' }}</option>
                    <option v-for="className in classes" :key="className" :value="className">{{ className }}</option>
                  </select>
                </div>
              </div> -->
              <!-- <div v-if="!editMode && isCreatingNew" style="display: flex; gap: 8px; align-items: center">
                <input type="text" v-model.trim="classSelectionMode" :class="{ 'text-input': true, 'error-border': showErrors && (errors.name || !isClassNameUnique) }" placeholder="Enter Class Name" style="flex: 1; padding: 8px; border: 1px solid #ccc; border-radius: 4px" />
                <button @click="cancelCreateNew" type="button" style="background: #6c757d; color: white; border: none; padding: 8px 12px; border-radius: 4px; font-size: 12px; cursor: pointer">Cancel</button>
              </div> -->
              <!-- Error message for duplicate class name - only show when creating new class -->
              <!-- <p v-if="isCreatingNew && classSelectionMode && !isClassNameUnique" class="error-message">
                <strong>Duplicate Class Name:</strong>
                A class with this name already exists. Please choose a different name.
              </p>
              <input v-if="editMode" type="text" v-model.trim="newClass.name" :class="{ 'error-border': showErrors && errors.name }" placeholder="Enter Class Name" /> -->
              <!-- <span class="error-text" v-if="showErrors && errors.name">{{ errors.name }}</span> -->
            </div>
            <!-- <label class="input-label">Document Type Name</label>
            <input class="text-input" readonly type="text" v-model="blueprintName" placeholder="Enter document type variant name" autocomplete="off" /> -->
            <!-- Error message shown only if invalid -->
            <!-- <p v-if="!isNameValid" class="error-message">
              <strong>Invalid Name:</strong>
              {{ blueprintNameErrorMessage }}
            </p> -->
            <!-- Error message for duplicate blueprint name -->
            <!-- <p v-if="blueprintName && !isBlueprintNameUnique" class="error-message">
              <strong>Duplicate Name:</strong>
              A document type variant with this name already exists. Please choose a different name.
            </p> -->
            <div class="upload-dropzone" @click="triggerFileSelect" @dragover.prevent @drop.prevent="onDrop" :class="{ disabled: !!selectedFile }">
              <div class="cloud-circle">
                <svg width="101" height="101" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="100" height="100" rx="55" fill="#F0F9FD" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M37.5 58.5429H73.5C75.8869 58.5429 78.1761 57.5813 79.864 55.8697C81.5518 54.1581 82.5 51.8367 82.5 49.4161C82.5 46.9956 81.5518 44.6741 79.864 42.9625C78.1761 41.2509 75.8869 40.2894 73.5 40.2894C72.66 40.2894 72.24 40.2894 71.949 40.2285C71.055 40.046 70.629 39.7691 70.101 39.0147C69.927 38.7713 69.681 38.2176 69.192 37.1102C68.0096 34.4303 66.0876 32.1546 63.6581 30.5578C61.2285 28.961 58.3952 28.1113 55.5 28.1113C52.6048 28.1113 49.7715 28.961 47.3419 30.5578C44.9124 32.1546 42.9904 34.4303 41.808 37.1102C41.319 38.2176 41.073 38.7682 40.899 39.0147C40.371 39.7691 39.945 40.049 39.051 40.2316C38.757 40.2894 38.34 40.2894 37.5 40.2894C35.1131 40.2894 32.8239 41.2509 31.136 42.9625C29.4482 44.6741 28.5 46.9956 28.5 49.4161C28.5 51.8367 29.4482 54.1581 31.136 55.8697C32.8239 57.5813 35.1131 58.5429 37.5 58.5429Z" fill="#7AC4EB" fill-opacity="0.34" />
                  <path d="M48 53.9797L55.5 46.374M55.5 46.374L63 53.9797M55.5 46.374V76.7966" stroke="#164863" stroke-linecap="round" />
                </svg>
              </div>
              <div class="dropzone-instructions">
                {{ t('documentTraining.dropFilesHere') }}
                <span class="click-link" @click.stop="triggerFileSelect">{{ t('documentTraining.clickToUpload') }}</span>
              </div>
              <div class="file-types">{{ t('documentTraining.supportedFormats') }}: {{ allowedFileFormats.displayText }}</div>
              <div class="file-types">{{ t('documentTraining.maxFileSize') }}</div>
              <div class="file-types">{{ t('documentTraining.uploadNote') }}</div>
              <input ref="fileInputRef" type="file" :accept="allowedFileFormats.extensions" hidden @change="handleFileChange" />
            </div>
            <div v-if="selectedFile" class="selected-file">
              <strong>{{ t('documentTraining.selectedFile') }}</strong>
              <span>{{ selectedFile.name }}</span>
              <button class="cancel-btn" @click="cancelSelectedFile" type="button" :aria-label="t('documentTraining.cancelFileSelection')">✕</button>
            </div>
            <button class="upload-btn" :disabled="!isUploadButtonEnabled" @click="uploadFileToS3(selectedFile)">{{ t('documentTraining.uploadAndProcess') }}</button>
            <!-- Debug info - remove this after fixing -->
          </div>
        </template>
      </template>
      <ErrorPopup :open="popupOpen" :message="popupMessage" :title="popupTitle" :onDone="closePopup" />
    </div>
    <!-- Step 2: Document Preview -->
    <DocumentPreview :blueprintName="blueprintName" :classSelectionMode="classSelectionMode" v-if="step === 'preview'" :s3DocumentUrl="fileS3Url" :blueprintSchema="blueprintSchema" :selectedFile="selectedFile" :setBlueprintSchema="setBlueprintSchema" :setFinalResult="setFinalResult" :blueprintArn="blueprintArn" :finalResult="finalResult" :docArray="docArray" @complete="handlePreview" @displayNameChange="handleDisplayNameChange" :isEditMode="true" :selectedTenantUsesBedrock="selectedTenantUsesBedrock" :selectedTenantUsesTextract="selectedTenantUsesTextract" />
    <!-- Step 3: Field Mapping -->
    <BDAExtraction
      v-if="step === 'fieldMapping'"
      :documentTypeName="getDocumentTypeName()"
      :sourceDocumentName="selectedFile?.name || ''"
      :tenantId="Number(route.query.tenant_id)"
      :documentTypeId="route.query.document_type_id"
      :blueprintArn="blueprintArn"
      :blueprintSchema="blueprintSchema"
      :isStepMode="true"
      :selectedTenantUsesBedrock="selectedTenantUsesBedrock"
      :selectedTenantUsesTextract="selectedTenantUsesTextract"
      @complete="handleFieldMapping"
      :isEditFlow="isEditFlow"
      :presetVasionFormId="collectedStepData.bdaExtractionData.selectedVasionFormId || presetVasionFormId"
      :presetFieldMappings="
        (() => {
          const mappings = collectedStepData.bdaExtractionData.extractionMappingList.length > 0 ? collectedStepData.bdaExtractionData.extractionMappingList : presetFieldMappings
          console.log('🚀 Uploads: Passing presetFieldMappings to BDAExtraction:', mappings?.length || 0, 'items')
          return mappings
        })()
      "
    />
    <!-- Step 4: Configure Settings -->
    <ConfigureVasionSettings v-if="step === 'allset'" :fileS3Url="fileS3Url" :documentTypeName="getDocumentTypeName()" :isStepMode="true" :isEditMode="isEditMode" :tenantId="Number(route.query.tenant_id)" :selectedTenantUsesBedrock="selectedTenantUsesBedrock" :selectedTenantUsesTextract="selectedTenantUsesTextract" :collectedStepData="collectedStepData" :blueprintSchema="blueprintSchema" :selectedFileName="selectedFile?.name || ''" @complete="handleCompletion" @state-change="handleVasionSettingsStateChange" :blueprintName="blueprintName" :existingVasionSettings="collectedStepData.vasionSettingsData && Object.keys(collectedStepData.vasionSettingsData).some((k) => collectedStepData.vasionSettingsData[k] !== '' && collectedStepData.vasionSettingsData[k] !== null) ? collectedStepData.vasionSettingsData : savedVasionSettings" :textractAnalysisType="textractAnalysisType" :uploadedFilePagesCount="uploadedFilePagesCount" />
    <!-- Step 4: Show success message -->
  </AppLayout>
</template>

<script setup>
import AppLayout from '../components/AppLayout.vue'
import { ref, reactive, watch, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
// import Popup from '../components/Popup.vue' // Not used
import ErrorPopup from '../components/ErrorPopup.vue' // Adjust the path as needed
import DocumentPreview from '../components/DocumentPreview.vue'
import { convertJpegToImageArray, convertPdfToImageArray, convertTiffToImageArray, mergeExplainabilityInfo, pollForStatus } from '../utils/utils'
import * as pdfjsLib from 'pdfjs-dist'
import * as UTIF from 'utif'
import ConfigureVasionSettings from '../../../components/ConfigureVasionSettings/ConfigureVasionSettings.vue'
import BDAExtraction from '../../../components/BDAExtraction/BDAExtraction.vue'
import { post, get, put, getBinary } from '../../../utils/api.js'
import { isAiMethodBedrockForTenant, isAiMethodTextractForTenant } from '../../../utils/tenantUtils.js'
import { showToast } from '@/utils/toast'
const { t } = useI18n()

const router = useRouter()
const route = useRoute()
const presetVasionFormId = ref(null)
const presetFieldMappings = ref(null)
const savedVasionSettings = ref(null)
const uploadedFilePagesCount = ref(0)
const existingDocumentTypeName = ref([])
// Determine if we're in edit mode based on presence of document_type_id
const isEditMode = computed(() => Boolean(route.query.document_type_id))

// Configure PDF.js worker with fallbacks
const configurePdfWorker = () => {
  const version = pdfjsLib.version
  const workerUrls = [`https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.js`, `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.js`, `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`]

  // Try the first URL
  pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrls[0]
}

// Computed property to check if blueprint name is unique
const isBlueprintNameUnique = computed(() => {
  if (!blueprintName.value || !blueprintNames.value || blueprintNames.value.length === 0) {
    return true
  }
  return !blueprintNames.value.some((blueprint) => blueprint.BlueprintName?.toLowerCase() === blueprintName.value.toLowerCase())
})

// Computed property to check if the form is valid
const isFormValid = computed(() => {
  // Debug logging to see what's happening

  // If creating a new class, check class name uniqueness as well
  if (isCreatingNew.value && classSelectionMode.value) {
    const result = isNameValid.value && isBlueprintNameUnique.value && isClassNameUnique.value
    return result
  }
  // If selecting an existing class, just check blueprint name validity
  if (classSelectionMode.value && !isCreatingNew.value) {
    const result = isNameValid.value && isBlueprintNameUnique.value
    return result
  }
  // If no class selected, form is not valid
  return false
})

// Computed property to check if class name is unique
const isClassNameUnique = computed(() => {
  if (!classSelectionMode.value || !blueprintNames.value || blueprintNames.value.length === 0) {
    return true
  }
  return !blueprintNames.value.some((blueprint) => blueprint.ClassName?.toLowerCase() === classSelectionMode.value.toLowerCase())
})

configurePdfWorker()

// Helper function to get MIME type from file extension
const getMimeTypeFromExtension = (extension) => {
  const mimeTypes = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    tif: 'image/tiff',
    tiff: 'image/tiff',
  }
  return mimeTypes[extension] || 'application/octet-stream'
}

// Helper function to create doc array from S3 URL
const createDocArrayFromS3Url = async (s3Url, fileName, mimeType) => {
  try {
    if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
      // For images, create single page doc array
      return [
        {
          id: '1',
          name: fileName,
          imageUrl: s3Url, // Use S3 URL directly as image source
        },
      ]
    } else if (mimeType === 'application/pdf' || mimeType === 'image/tiff') {
      // For PDFs and TIFFs, we can't easily determine page count from S3 URL
      // Create a placeholder doc array with the S3 URL
      // In a real scenario, you might need to fetch the file and process it
      return [
        {
          id: '1',
          name: `${fileName} - Page 1`,
          imageUrl: s3Url, // Use S3 URL as placeholder
        },
      ]
    } else {
      // Fallback for unknown file types
      return [
        {
          id: '1',
          name: fileName,
          imageUrl: s3Url,
        },
      ]
    }
  } catch (error) {
    console.error('Error creating doc array from S3 URL:', error)
    // Return fallback doc array
    return [
      {
        id: '1',
        name: fileName,
        imageUrl: s3Url,
      },
    ]
  }
}

// If coming from edit flow and requested to resume at extraction, preload state and jump steps
onMounted(async () => {
  // Check if this is an edit flow from DocumentType.vue
  if (route.query.isEditFlow === 'true' && route.query.document_type_id && route.query.tenant_id) {
    isEditFlow.value = true

    try {
      console.log('Edit flow detected with document_type_id:', route.query.document_type_id)

      // Set loading state for edit mode
      isLoadingEditData.value = true

      // Check if tenant uses Bedrock or Textract
      selectedTenantUsesBedrock.value = await isAiMethodBedrockForTenant(route.query.tenant_id)
      selectedTenantUsesTextract.value = await isAiMethodTextractForTenant(route.query.tenant_id)
      isLoading.value = false
      // Fetch all training data from API based on tenant type
      // Note: Don't set fileUploading here since we're not actually uploading
      let response
      if (selectedTenantUsesTextract.value) {
        // For Textract tenants, use Textract API
        response = await get(`/v1/textract/get-saved-training-data-for-edit?documentTypeId=${route.query.document_type_id}`)
      } else {
        // For Bedrock tenants, use Bedrock API
        response = await get(`/v1/bedrock/get-saved-training-data-for-edit?tenantDocumentId=${route.query.document_type_id}`)
      }

      if (response?.status === 200 && response.data) {
        console.log('Fetched training data for edit:', response.data)

        // ASSIGN ALL VARIABLES FROM API RESPONSE:
        // 1. Basic document info
        const data = response?.data?.data
        blueprintName.value = data.docPreviewData?.blueprintName
        editableDisplayName.value = data.tenantDocumentType?.document_type_display_name
        uploadedFilePagesCount.value = data.tenantDocumentType?.uploaded_file_pages_count

        // 2. Blueprint/Schema data
        blueprintArn.value = data?.docPreviewData?.blueprintArn

        // Handle blueprint schema - backend returns string from database that needs parsing
        const rawBlueprintSchema = data?.docPreviewData?.blueprintSchema
        try {
          if (!rawBlueprintSchema) {
            blueprintSchema.value = { properties: {} } // Fallback empty schema
          } else if (typeof rawBlueprintSchema === 'string') {
            // Backend returns JSON string from database, parse it
            const parsedSchema = JSON.parse(rawBlueprintSchema)
            blueprintSchema.value = parsedSchema
          } else if (typeof rawBlueprintSchema === 'object') {
            blueprintSchema.value = rawBlueprintSchema
          }

          // Ensure schema has properties field
          if (!blueprintSchema.value || !blueprintSchema.value.properties) {
            if (!blueprintSchema.value) blueprintSchema.value = {}
            blueprintSchema.value.properties = {}
          }
        } catch (error) {
          console.error('Error parsing blueprint schema:', error)
          console.error('Raw schema that caused error:', rawBlueprintSchema)
          // Fallback to empty schema
          blueprintSchema.value = { properties: {} }
        }

        // 3. Final result/extraction data - backend returns string from database
        const rawFinalResult = data?.docPreviewData?.finalResult

        try {
          if (!rawFinalResult) {
            finalResult.value = {} // Fallback empty result
          } else if (typeof rawFinalResult === 'string') {
            // Backend returns JSON string from database, parse it
            finalResult.value = JSON.parse(rawFinalResult)
          } else {
            // Already an object
            finalResult.value = rawFinalResult
          }
        } catch (error) {
          console.error('Error parsing final result:', error)
          console.error('Raw final result that caused error:', rawFinalResult)
          // Fallback to empty result
          finalResult.value = {}
        }
        presetVasionFormId.value = data?.tenantDocumentType?.vasion_form_id
        presetFieldMappings.value = data?.extractionMappingList
        console.log('📋 [EDIT FLOW - Textract] Loaded data:', {
          vasionFormId: presetVasionFormId.value,
          extractionMappings: presetFieldMappings.value?.length || 0,
          isTextract: selectedTenantUsesTextract.value,
          sampleMapping: presetFieldMappings.value?.[0],
        })

        // 4. File/document data - create file object and doc array from S3 URL
        if (data?.tenantDocumentType?.s3_url && data?.tenantDocumentType?.source_file_name) {
          // Get the S3 URL (axios will handle parameter encoding automatically)
          const s3Url = data?.tenantDocumentType.s3_url.trim()
          const sourceFileName = data?.tenantDocumentType.source_file_name
          try {
            // Create a pseudo-file object for edit flow
            const fileExtension = sourceFileName.split('.').pop().toLowerCase()
            const mimeType = getMimeTypeFromExtension(fileExtension)
            // Create a simple file-like object for reference
            selectedFile.value = {
              name: sourceFileName,
              type: mimeType,
              size: 0, // Size unknown from S3 URL
              lastModified: Date.now(),
              webkitRelativePath: '',
              // Add edit flow marker
              isFromEditFlow: true,
              s3Url: s3Url,
            }

            // For edit flow, use backend proxy to fetch the file from S3
            try {
              // Use getBinary method for binary data with authentication and base URL handling
              const response = await getBinary('/v1/s3/proxy-download', { s3_url: s3Url })

              if (response.status !== 200) {
                throw new Error(`Failed to fetch file via proxy: ${response.status} - ${response.statusText}`)
              }
              const blob = response.data // axios with responseType: 'blob' returns blob in response.data
              const file = new File([blob], sourceFileName, { type: mimeType })

              // Process the file same as in add flow to create proper doc array
              if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
                docArray.value = await convertJpegToImageArray(file)
              } else if (mimeType === 'application/pdf') {
                docArray.value = await convertPdfToImageArray(file)
              } else if (mimeType === 'image/tiff') {
                docArray.value = await convertTiffToImageArray(file)
              } else {
                // Fallback - use S3 URL directly
                docArray.value = await createDocArrayFromS3Url(s3Url, sourceFileName, mimeType)
              }
            } catch (fetchError) {
              console.error('Failed to fetch and process file from S3, falling back to direct URL:', fetchError)
              // Fallback to direct S3 URL if fetch fails
              docArray.value = await createDocArrayFromS3Url(s3Url, sourceFileName, mimeType)
            }
          } catch (error) {
            console.error('Error creating file object and doc array from S3 URL:', error)
            // Continue with edit flow even if doc array creation fails
          }
        }

        // 5. Step data collection
        collectedStepData.value.docPreviewData = {
          blueprintArn: blueprintArn.value,
          blueprintSchema: blueprintSchema.value,
          blueprintName: blueprintName.value,
          finalResult: finalResult.value,
          invocationArn: data?.docPreviewData?.invocationArn,
        }

        // 6. Field mapping data
        collectedStepData.value.extractionMappingList = data?.extractionMappingList

        // Transform backend splitting configuration to frontend format
        let detectionMode = 'auto' // default
        let splittingStrategy = ''
        let pageNumber = data?.vasionFields?.page_number || ''

        // Determine detection_mode based on backend fields
        if (data?.vasionFields?.page_number > 0) {
          // Page count mode
          detectionMode = 'page_count'
        } else if (data?.vasionFields?.split_on_code === true) {
          // QR or Barcode mode
          detectionMode = data?.vasionFields?.detection_mode || 'qr'
          splittingStrategy = data?.vasionFields?.splitting_strategy || ''
        } else {
          // Auto mode (no splitting)
          detectionMode = 'auto'
        }

        savedVasionSettings.value = {
          send_to_vasion_storage: data?.vasionFields?.send_to_vasion_storage || true,
          vasion_workflow_id: data?.vasionFields?.vasion_workflow_id || '',
          vasion_folder_id: data?.vasionFields?.vasion_folder_id || '',
          vasion_watch_folder_id: data?.vasionFields?.vasion_watch_folder_id || '',
          vasion_auto_import_enabled: data?.vasionFields?.vasion_auto_import_enabled,
          vasion_watch_interval_minutes: data?.vasionFields?.vasion_watch_interval_minutes,
          vasion_completion_folder_id: data?.vasionFields?.vasion_completion_folder_id || '',
          vasion_rejection_folder_id: data?.vasionFields?.vasion_rejection_folder_id || '',
          vasion_review_folder_id: data?.vasionFields?.vasion_review_folder_id || '',
          vasion_failed_folder_id: data?.vasionFields?.vasion_failed_folder_id || '',
          ml_confidence_level: data?.vasionFields?.ml_confidence_level || '',
          requires_complete_manual_validation: data?.vasionFields?.requires_complete_manual_validation || false,
          // Splitting configuration
          detection_mode: detectionMode,
          splitting_strategy: splittingStrategy,
          page_number: pageNumber,
        }

        // ENHANCEMENT: Also populate the persistence data structures
        collectedStepData.value.bdaExtractionData.selectedVasionFormId = data?.tenantDocumentType?.vasion_form_id
        collectedStepData.value.bdaExtractionData.extractionMappingList = data?.extractionMappingList || []
        console.log('📋 [EDIT FLOW - Textract] Populated bdaExtractionData:', {
          selectedVasionFormId: collectedStepData.value.bdaExtractionData.selectedVasionFormId,
          extractionMappingListCount: collectedStepData.value.bdaExtractionData.extractionMappingList?.length || 0,
        })
        collectedStepData.value.vasionSettingsData = { ...savedVasionSettings.value }
        // 7. Vasion configuration
        collectedStepData.value.vasionFields = data?.vasionFields

        // 8. File URLs (if needed for document preview)
        fileS3Url.s3Url = data?.tenantDocumentType?.s3_uri
        fileS3Url.httpsUrl = data?.tenantDocumentType?.s3_url

        // Clear loading state and go directly to Document Preview step for edit flow
        isLoadingEditData.value = false
        step.value = 'preview'
      } else {
        console.warn('Failed to fetch training data, staying on upload step')
        isLoadingEditData.value = false
      }
    } catch (error) {
      console.error('Error handling edit flow:', error)
      isEditFlow.value = false
      isLoadingEditData.value = false
    }
  }

  // Handle standard flow (non-edit)
  if (!isEditFlow.value) {
    isNewDocumentFlow.value = !route.query.displayName

    // Check if tenant uses Bedrock or Textract
    const tenantId = Number(route.query.tenant_id)
    if (tenantId) {
      selectedTenantUsesBedrock.value = await isAiMethodBedrockForTenant(tenantId)
      selectedTenantUsesTextract.value = await isAiMethodTextractForTenant(tenantId)
      isLoading.value = false
    }

    // Handle document_type_id in URL and session storage
    if (!route.query.document_type_id) {
      // No document_type_id in URL - check if we should restore from session or clear it
      const storedDocTypeId = sessionStorage.getItem('document_type_id')

      // Only restore if we're in edit mode (has mode=edit or resume=fieldMapping)
      if (storedDocTypeId && (route.query.mode === 'edit' || route.query.resume === 'fieldMapping')) {
        const newQuery = { ...route.query, document_type_id: storedDocTypeId }
        router.replace({ query: newQuery })
      } else if (!route.query.mode && !route.query.resume) {
        // This is a new document creation - clear any stale document_type_id
        sessionStorage.removeItem('document_type_id')
      }
    } else {
      // If we have document_type_id in URL, ensure it's also in session storage
      sessionStorage.setItem('document_type_id', String(route.query.document_type_id))
    }

    // Only fetch tenant document type if we have a document_type_id (editing/training existing document)
    if (route.query.document_type_id) {
      try {
        const tenantDocumentTypeRes = await get(`/v1/tenant-document-types/${route.query.document_type_id}`)
        tenantDocumentType.value = tenantDocumentTypeRes.data
        editMode.value = true // Set edit mode when we have document_type_id
      } catch (error) {
        console.error('Failed to fetch tenant document type:', error)
        // If we can't find the document type, clear the invalid ID
        sessionStorage.removeItem('document_type_id')
        const newQuery = { ...route.query }
        delete newQuery.document_type_id
        router.replace({ query: newQuery })
      }
    }

    // Fetch URL query parameters
    const displayNameRaw = route.query.displayName

    if (displayNameRaw) {
      // Existing flow with displayName provided - process it
      const tenantId = Number(route.query.tenant_id) || ''
      const timestamp = Date.now()
      const displayName = `${tenantId}_${timestamp}_${displayNameRaw}`

      // Decode the displayName from URL encoding
      const decodedDisplayName = decodeURIComponent(displayName)

      // Set as class name (if creating new class)
      if (decodedDisplayName) {
        isCreatingNew.value = true
        classSelectionMode.value = decodeURIComponent(route.query.displayName)
      }

      // Set as document type variant name
      blueprintName.value = decodedDisplayName
    }
    // For new document flow, blueprintName will be set from manualDocumentTypeName when uploading

    const blueprintArnQuery = route.query.blueprintArn

    // If blueprintArn is provided, store it
    if (blueprintArnQuery) {
      // You can use this blueprintArn if needed for additional functionality
    }

    // Only fetch classes if displayName is provided (existing document flow)
    if (displayNameRaw) {
      await fetchClasses() // Fetch classes only when needed
    }
    // await fetchBlueprintNames()
    await fetchDocumentTypesName()
  }
})

const fileInputRef = ref(null)
const selectedFile = ref(null)
const fileUploading = ref(false)
const isLoading = ref(true)
const isLoadingEditData = ref(false) // New loading state for edit mode data fetching
const messages = ref(t('documentTraining.loading'))
const showExtractionData = ref(false)
const classesLoading = ref(false)
const step = ref('upload')
const finalResult = ref({})
const blueprintName = ref('')
const tenantDocumentType = ref(null)
const isNameValid = ref(true)
const blueprintNameErrorMessage = ref('')
const manualDocumentTypeName = ref('')
const isNewDocumentFlow = ref(false)
const docArray = ref([])
const blueprintSchema = ref(null)
const blueprintArn = ref(null)
const isEditFlow = ref(false)
// existingBlueprintsNames is now replaced by blueprintNames
const projectArn = 'arn:aws:bedrock:us-east-1:692859933965:data-automation-project/79d3fa7dfb1e'
const fileS3Url = reactive({
  s3Url: '',
  httpsUrl: '',
})

// Reactive data properties
const classes = ref([])
const blueprintNames = ref([])
const editMode = ref(false)
const classSelectionMode = ref('')
const isCreatingNew = ref(false)
const showErrors = ref(false)
const errors = reactive({
  name: '',
  description: '',
  project_id: '',
})
const newClass = reactive({
  name: '',
  description: '',
  project_id: '',
  is_active: true,
})

// Add state for selectedTenantUsesBedrock
const selectedTenantUsesBedrock = ref(false)

// Add state for selectedTenantUsesTextract
const selectedTenantUsesTextract = ref(false)

// Textract-specific state
const textractAnalysisType = ref('')
const showTextractError = ref(false)

// Computed property to check if this is a Textract flow
const isTextractFlow = computed(() => {
  return route.query.isTextract === 'true'
})

// Computed property for allowed file formats based on Textract analysis type
const allowedFileFormats = computed(() => {
  if (!selectedTenantUsesTextract.value || !isTextractFlow.value) {
    // Default: all formats allowed for Bedrock or non-Textract flows
    return {
      mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
      extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
      displayText: 'PDF, PNG, JPEG, TIFF',
    }
  }

  // Textract-specific format restrictions based on analysis type
  switch (textractAnalysisType.value) {
    case 'AnalyzeDocument':
      // Async API - supports multipage PDF/TIFF
      return {
        mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
        extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
        displayText: 'PDF, PNG, JPEG, TIFF ',
      }
    case 'AnalyzeExpense':
      // Async API - supports multipage PDF/TIFF
      return {
        mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
        extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
        displayText: 'PDF, PNG, JPEG, TIFF ',
      }
    case 'AnalyzeID':
      // Synchronous API only - single page documents only (AWS limitation)
      return {
        mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
        extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
        displayText: 'PDF, PNG, JPEG, TIFF (single page only)',
      }
    case 'AnalyzeLending':
      // Async API - supports multipage PDF/TIFF
      return {
        mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
        extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
        displayText: 'PDF, PNG, JPEG, TIFF ',
      }
    default:
      // If no analysis type selected yet, show all formats
      return {
        mimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
        extensions: '.pdf,.png,.jpg,.jpeg,.tiff,.tif',
        displayText: 'PDF, PNG, JPEG, TIFF',
      }
  }
})

// Add state to store data from different steps
const collectedStepData = ref({
  docPreviewData: {},
  extractionMappingList: [],
  vasionFields: {},
  // Enhanced persistence for BDAExtraction
  bdaExtractionData: {
    selectedVasionFormId: null,
    extractionMappingList: [],
  },
  // Enhanced persistence for ConfigureVasionSettings
  vasionSettingsData: {
    send_to_vasion_storage: true,
    vasion_workflow_id: '',
    vasion_folder_id: '',
    vasion_rejection_folder_id: '',
    vasion_review_folder_id: '',
    vasion_failed_folder_id: '',
    ml_confidence_level: '',
    requires_complete_manual_validation: false,
    detection_mode: 'auto',
    page_number: '',
  },
})

// Store the editable display name
const editableDisplayName = ref('')

// Watch for changes to editableDisplayName to debug overwrites
watch(
  editableDisplayName,
  (newValue, oldValue) => {
    console.log('🔍 editableDisplayName changed:', {
      from: oldValue,
      to: newValue,
      stack: new Error().stack,
    })
  },
  { immediate: true }
)

// Regex: allows letters, numbers, hyphens, underscores, and spaces
const validNameRegex = /^[a-zA-Z0-9-_ ]+$/

// Computed property to check if upload button should be enabled
const isUploadButtonEnabled = computed(() => {
  // Basic requirements: file must be selected and not currently uploading
  if (!selectedFile.value || fileUploading.value) {
    return false
  }

  // For Textract flow, also require analysis type selection
  if (selectedTenantUsesTextract.value && isTextractFlow.value) {
    if (!textractAnalysisType.value) {
      return false
    }
  }

  // If creating new document (no displayName in route), require valid manual document type name
  if (!route.query.displayName) {
    // For new document flow: need valid document type name AND file
    return manualDocumentTypeName.value && manualDocumentTypeName.value.trim() && isNameValid.value
  }

  // For existing flow with displayName provided, file selection is sufficient
  return true
})

// Function to handle manual name input
const handleManualNameInput = () => {
  // Check if the value is null or undefined
  if (!manualDocumentTypeName.value) {
    isNameValid.value = false
    return
  }

  const trimmed = manualDocumentTypeName.value.trim()

  // Reset error message
  blueprintNameErrorMessage.value = ''

  // Check if input is empty or contains only spaces
  if (!trimmed) {
    isNameValid.value = false
    blueprintNameErrorMessage.value = t('uploads.validation.name_cannot_be_empty')
    return
  }

  // Check maximum length (50 characters)
  if (trimmed.length > 50) {
    isNameValid.value = false
    blueprintNameErrorMessage.value = t('uploads.validation.name_max_length')
    return
  }

  // Check regex (now allows spaces)
  const isRegexValid = validNameRegex.test(trimmed)

  if (!isRegexValid) {
    isNameValid.value = false
    blueprintNameErrorMessage.value = t('uploads.validation.name_invalid_characters')
    return
  }

  // If all validations pass
  isNameValid.value = true
}

watch(blueprintName, (newVal) => {
  // Check if newVal is null or undefined
  if (!newVal) {
    isNameValid.value = false
    return
  }

  // Trim leading/trailing spaces and replace internal spaces with underscores
  const trimmed = newVal.trim().replace(/\s+/g, '_')
  blueprintName.value = trimmed

  // Reset error message
  blueprintNameErrorMessage.value = ''
  //
  // Check regex first (validate the processed name without spaces)
  const isRegexValid = /^[a-zA-Z0-9-_]+$/.test(trimmed)
  const isDuplicate = blueprintNames?.value?.some((blueprint) => blueprint.BlueprintName === trimmed)

  if (!isRegexValid) {
    isNameValid.value = false
    blueprintNameErrorMessage.value = t('uploads.validation.name_invalid_characters')
    return
  }

  // if (isDuplicate) {
  //   isNameValid.value = false
  //   blueprintNameErrorMessage.value = `Document type name already exists. It must be unique.`
  //   return
  // }

  // If both checks pass
  isNameValid.value = true
})

// Watch for Textract analysis type changes to clear error and validate selected file
watch(textractAnalysisType, (newVal, oldVal) => {
  if (newVal) {
    showTextractError.value = false
  }

  // If analysis type changed and a file is already selected, validate it against new format requirements
  if (selectedFile.value && newVal && oldVal && newVal !== oldVal) {
    const isValidType = allowedFileFormats.value.mimeTypes.includes(selectedFile.value.type)
    if (!isValidType) {
      // Clear the selected file if it's not compatible with new analysis type
      const fileName = selectedFile.value.name
      selectedFile.value = null
      if (fileInputRef.value) fileInputRef.value.value = ''
      showToast({
        title: t('common.warning'),
        message: `File "${fileName}" is not compatible with ${newVal}. Please select ${allowedFileFormats.value.displayText}.`,
        type: 'warning',
      })
    }
  }
})

// Watch for class selection mode changes to provide real-time validation
watch(classSelectionMode, (newVal) => {
  if (isCreatingNew.value && newVal) {
    // Check if newVal is null or undefined
    if (!newVal || typeof newVal !== 'string') {
      return
    }

    // Trim the class name and replace spaces with underscores
    const trimmed = newVal.trim().replace(/\s+/g, '_')
    classSelectionMode.value = trimmed

    // Check if the class name is valid (regex) - validate processed name without spaces
    const isRegexValid = /^[a-zA-Z0-9-_]+$/.test(trimmed)
    if (!isRegexValid) {
      // Show error for invalid class name format
      showErrors.value = true
      errors.name = t('uploads.validation.name_invalid_characters')
      return
    }

    // Check if the class name is unique
    if (!isClassNameUnique.value) {
      showErrors.value = true
      errors.name = t('uploads.errors.document_type_exists')
      return
    }

    // If both checks pass, clear errors
    showErrors.value = false
    errors.name = ''
  }
})

// Popup state
const popupOpen = ref(false)
const popupMessage = ref('')
const popupTitle = ref('')

// Utility functions
function showPopup(msg, title) {
  popupMessage.value = msg
  popupTitle.value = title
  popupOpen.value = true
}

function closePopup() {
  popupOpen.value = false
}
function cancelSelectedFile() {
  selectedFile.value = null
  // Optionally also reset file input value for repeated uploads of same file
  if (fileInputRef.value) fileInputRef.value.value = ''
}
async function fetchBlueprintNames() {
  try {
    // const userData = JSON.parse(localStorage.getItem('UserData'))
    const tenantId = Number(route.query.tenant_id)
    if (!tenantId) return
    // let url = `/v1/classes?tenant_id=${this.selectedTenant}&page=${this.page}&pageSize=${this.pageSize}`
    let url = `/v1/bedrock/list-blueprints?tenantId=${tenantId}`
    // if (this.search) {
    //   url += `&search=${encodeURIComponent(this.search)}`
    // }
    const response = await get(url)
    if (response?.status === 200) {
      blueprintNames.value = response?.data?.blueprints?.sort((a, b) => a?.ClassName?.localeCompare(b?.ClassName))
    }
  } catch (err) {}
}
async function fetchDocumentTypesName() {
  const tenantId = Number(route.query.tenant_id)
  if (!tenantId) return
  const response = await get(`/v1/tenant-document-types?page=1&pageSize=1000&tenantId=${tenantId}&isDeleted=false`)
  if (response?.data?.code === 200) {
    const nameArr = response?.data?.data?.data?.map((docType) => docType.document_type_display_name)
    existingDocumentTypeName.value = nameArr
  }
}
async function handleFileChange(event) {
  const file = event.target.files?.[0]
  if (!file) {
    return
  }

  // Validate file type against allowed formats
  const isValidType = allowedFileFormats.value.mimeTypes.includes(file.type)

  if (!isValidType) {
    selectedFile.value = null
    const errorMsg = selectedTenantUsesTextract.value && isTextractFlow.value && textractAnalysisType.value ? `${t('uploads.errors.file_type_not_allowed')} For ${textractAnalysisType.value}, only ${allowedFileFormats.value.displayText} are supported.` : t('uploads.errors.file_type_not_allowed')
    showPopup(errorMsg, t('common.error'))
    return
  }

  // For AnalyzeID, validate single-page requirement for PDF/TIFF
  if (selectedTenantUsesTextract.value && isTextractFlow.value && textractAnalysisType.value === 'AnalyzeID') {
    if (file.type === 'application/pdf') {
      try {
        const pageCount = await getPdfPageCount(file)
        if (pageCount > 1) {
          selectedFile.value = null
          showPopup(`AnalyzeID only supports single-page documents. The uploaded PDF has ${pageCount} pages. Please upload a single-page PDF or use PNG/JPEG format.`, t('common.error'))
          if (fileInputRef.value) fileInputRef.value.value = ''
          return
        }
      } catch (error) {
        console.error('Error checking PDF page count:', error)
        showPopup('Error validating PDF. Please try again or use PNG/JPEG format.', t('common.error'))
        selectedFile.value = null
        if (fileInputRef.value) fileInputRef.value.value = ''
        return
      }
    } else if (file.type === 'image/tiff') {
      try {
        const pageCount = await getTiffPageCount(file)
        if (pageCount > 1) {
          selectedFile.value = null
          showPopup(`AnalyzeID only supports single-page documents. The uploaded TIFF has ${pageCount} pages. Please upload a single-page TIFF or use PNG/JPEG format.`, t('common.error'))
          if (fileInputRef.value) fileInputRef.value.value = ''
          return
        }
      } catch (error) {
        console.error('Error checking TIFF page count:', error)
        showPopup('Error validating TIFF. Please try again or use PNG/JPEG format.', t('common.error'))
        selectedFile.value = null
        if (fileInputRef.value) fileInputRef.value.value = ''
        return
      }
    }
  }

  selectedFile.value = file
}

async function onDrop(event) {
  const file = event.dataTransfer.files[0]
  if (!file) {
    return
  }

  // Validate file type against allowed formats
  const isValidType = allowedFileFormats.value.mimeTypes.includes(file.type)

  if (!isValidType) {
    selectedFile.value = null
    const errorMsg = selectedTenantUsesTextract.value && isTextractFlow.value && textractAnalysisType.value ? `${t('uploads.errors.file_type_not_allowed')} For ${textractAnalysisType.value}, only ${allowedFileFormats.value.displayText} are supported.` : t('uploads.errors.file_type_not_allowed')
    showPopup(errorMsg, t('common.error'))
    return
  }

  // For AnalyzeID, validate single-page requirement for PDF/TIFF
  if (selectedTenantUsesTextract.value && isTextractFlow.value && textractAnalysisType.value === 'AnalyzeID') {
    if (file.type === 'application/pdf') {
      try {
        const pageCount = await getPdfPageCount(file)
        if (pageCount > 1) {
          selectedFile.value = null
          showPopup(`AnalyzeID only supports single-page documents. The uploaded PDF has ${pageCount} pages. Please upload a single-page PDF or use PNG/JPEG format.`, t('common.error'))
          return
        }
      } catch (error) {
        console.error('Error checking PDF page count:', error)
        showPopup('Error validating PDF. Please try again or use PNG/JPEG format.', t('common.error'))
        selectedFile.value = null
        return
      }
    } else if (file.type === 'image/tiff') {
      try {
        const pageCount = await getTiffPageCount(file)
        if (pageCount > 1) {
          selectedFile.value = null
          showPopup(`AnalyzeID only supports single-page documents. The uploaded TIFF has ${pageCount} pages. Please upload a single-page TIFF or use PNG/JPEG format.`, t('common.error'))
          return
        }
      } catch (error) {
        console.error('Error checking TIFF page count:', error)
        showPopup('Error validating TIFF. Please try again or use PNG/JPEG format.', t('common.error'))
        selectedFile.value = null
        return
      }
    }
  }

  selectedFile.value = file
}

async function getSchemaFromLLM(s3url) {
  const tenantId = Number(route.query.tenant_id)
  const payload = {
    s3url: s3url,
    tenantId: tenantId,
  }
  try {
    // Step 1: Trigger async schema generation
    console.log('📤 Initiating async schema generation...')
    const initiateRes = await post(`/v1/bedrock/generate-schema`, { ...payload, tenantId: tenantId })

    if (!initiateRes.data.success || !initiateRes.data.request_id) {
      throw new Error(initiateRes.data.message || 'Failed to start schema generation')
    }

    const requestId = initiateRes.data.request_id
    console.log('✅ Schema generation initiated with request_id:', requestId)

    // Step 2: Poll for schema generation status every 10 seconds
    let isComplete = false
    let pollCount = 0
    const maxPolls = 120 // 20 minutes max (120 * 10 seconds)

    while (!isComplete && pollCount < maxPolls) {
      // Wait 10 seconds before polling (except on first check)
      if (pollCount > 0) {
        await new Promise((resolve) => setTimeout(resolve, 10000))
      }

      pollCount++
      console.log(`⏳ Poll attempt ${pollCount}/${maxPolls} for request_id: ${requestId}`)

      try {
        const statusRes = await get(`/v1/bedrock/schema-status/${requestId}`)
        const statusData = statusRes.data

        if (!statusData.success) {
          throw new Error(statusData.error || 'Failed to fetch schema status')
        }

        const status = statusData.status
        console.log(`📊 Schema generation status: ${status}`)

        if (status === 'completed') {
          console.log('✅ Schema generation completed successfully')
          isComplete = true
          // Return the schema data in the expected format
          return {
            success: true,
            schema: statusData.schema,
            request_id: requestId,
          }
        } else if (status === 'failed') {
          throw new Error(statusData.error || 'Schema generation failed on backend')
        } else if (status === 'pending' || status === 'inprogress') {
          // Still processing, continue polling
          console.log(`⏳ Schema generation still ${status}, will check again in 10 seconds...`)
          const displayStatus = status === 'inprogress' ? 'In Progress' : status
          messages.value = `${t('documentTraining.generatingSchema')} (${displayStatus}...)`
        }
      } catch (pollError) {
        // Log polling error but continue if it's a transient error
        if (pollError.response?.status === 404) {
          // Request ID not found yet, continue polling
          console.log('⏳ Request not yet available, continuing to poll...')
        } else {
          // Real error, throw it
          throw pollError
        }
      }
    }

    // Timeout reached
    if (!isComplete) {
      throw new Error(`Schema generation timed out after ${maxPolls * 10} seconds`)
    }
  } catch (error) {
    console.error('❌ Error in getSchemaFromLLM:', error)
    throw error
  }
}

function triggerFileSelect() {
  if (fileInputRef.value) fileInputRef.value.click()
}

function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result
      if (typeof result === 'string') {
        const base64 = result.split(',')[1]
        resolve(base64)
      } else {
        reject('Failed to read file')
      }
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

async function uploadToApi(base64, name, type) {
  // const userData = JSON.parse(localStorage.getItem('UserData'))
  const tenantId = Number(route.query.tenant_id)
  const payload = {
    buffer: base64,
    name,
    type,
    tenantId: Number(tenantId),
  }
  const res = await post(`/v1/bedrock/upload`, payload)
  // if (!res.ok) thro
  // w new Error('Upload failed')
  return res.data
}

async function getPdfPageCount(file) {
  return new Promise((resolve, reject) => {
    // Force reconfigure worker before processing
    configurePdfWorker()
    const fileReader = new FileReader()
    fileReader.onload = async (e) => {
      try {
        const typedArray = new Uint8Array(e.target.result)
        const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise
        uploadedFilePagesCount.value = pdf.numPages
        resolve(pdf.numPages)
      } catch (error) {
        reject(error)
      }
    }
    fileReader.onerror = (e) => {
      reject(e)
    }
    fileReader.readAsArrayBuffer(file)
  })
}
async function getTiffPageCount(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      try {
        const ifds = UTIF.decode(reader.result)
        uploadedFilePagesCount.value = ifds.length
        resolve(ifds.length) // number of IFDs == number of pages
      } catch (e) {
        reject(e.message)
      }
    }
    reader.onerror = () => reject('Error reading file')
    reader.readAsArrayBuffer(file)
  })
}

// ==================== TEXTRACT ADAPTER ====================
/**
 * Helper function to extract bounding box from Textract Blocks array by matching text
 * Used for AnalyzeID since geometry is not included in IdentityDocumentFields
 */
function extractBoundingBoxFromBlocks(blocks, searchText) {
  if (!blocks || !searchText || searchText.trim() === '') {
    return null
  }

  // Normalize search text for comparison (trim and handle multi-space)
  const normalizedSearch = searchText.trim().toUpperCase()

  // First try to find exact match in LINE blocks (they have complete text)
  const lineBlock = blocks.find((block) => block.BlockType === 'LINE' && block.Text && block.Text.trim().toUpperCase() === normalizedSearch)

  if (lineBlock && lineBlock.Geometry && lineBlock.Geometry.BoundingBox) {
    return lineBlock.Geometry.BoundingBox
  }

  // If no LINE match, try WORD blocks
  const wordBlock = blocks.find((block) => block.BlockType === 'WORD' && block.Text && block.Text.trim().toUpperCase() === normalizedSearch)

  if (wordBlock && wordBlock.Geometry && wordBlock.Geometry.BoundingBox) {
    return wordBlock.Geometry.BoundingBox
  }

  // If still no match and search text contains multiple words, try to find blocks that contain the text
  const containsBlock = blocks.find((block) => (block.BlockType === 'LINE' || block.BlockType === 'WORD') && block.Text && block.Text.trim().toUpperCase().includes(normalizedSearch))

  if (containsBlock && containsBlock.Geometry && containsBlock.Geometry.BoundingBox) {
    return containsBlock.Geometry.BoundingBox
  }

  console.warn(`⚠️ Could not find bounding box for text: "${searchText}"`)
  return null
}

/**
 * Transforms Textract API response to Bedrock-compatible format
 * so downstream components (DocumentPreview, BDAExtraction, etc.) can work seamlessly
 */
function transformTextractResponseToBedrockFormat(textractResponse, analysisType, documentName, jobId) {
  console.log('🔄 Transforming Textract response to Bedrock format', { analysisType, jobId })

  const properties = {}
  let explainabilityInfo = []

  try {
    switch (analysisType) {
      case 'AnalyzeDocument':
        // Extract KEY_VALUE_SET blocks from Textract - handle multipage
        if (textractResponse.Blocks) {
          const keyValuePairs = extractKeyValuePairs(textractResponse.Blocks)

          keyValuePairs.forEach((pair, index) => {
            // Create unique key if same field appears on multiple pages
            const fieldKey = pair.key
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/[^a-z0-9_]/g, '')

            // If field already exists and from different page, ignore it and continue
            if (properties[fieldKey] && properties[fieldKey].page !== pair.page) {
              // Keep field from first occurrence
              // Future: Can append page suffix if needed
              // fieldKey = `${fieldKey}_page_${pair.page}`
              console.log(`⏭️ AnalyzeDocument: Skipping duplicate field "${fieldKey}" from page ${pair.page} (already exists from page ${properties[fieldKey].page})`)
              return
            }

            properties[fieldKey] = {
              type: 'string',
              value: pair.value || '',
              confidence: pair.confidence || 0,
              instruction: `Extract ${pair.key} from page ${pair.page}`,
              page: pair.page || 1,
              boundingBox: pair.boundingBox,
              isEditing: false,
            }
          })
        }
        console.log(`✅ AnalyzeDocument: Extracted ${Object.keys(properties).length} fields from multipage document`)
        break

      case 'AnalyzeExpense':
        // Extract expense fields from Textract - process ALL pages
        console.log('textractResponse===>', textractResponse)

        if (textractResponse.ExpenseDocuments && textractResponse.ExpenseDocuments.length > 0) {
          const lineItems = []
          let summaryFieldCounter = 0

          // Iterate through ALL expense documents (all pages)
          textractResponse.ExpenseDocuments.forEach((expenseDoc, docIndex) => {
            console.log(`Processing Expense Document ${docIndex + 1}/${textractResponse.ExpenseDocuments.length}`)

            // Extract summary fields from all pages
            expenseDoc.SummaryFields?.forEach((field) => {
              const fieldKey = (field.Type?.Text || 'field').toLowerCase().replace(/\s+/g, '_')

              // If field already exists and from different page, ignore it and continue
              if (properties[fieldKey] && properties[fieldKey].page !== docIndex + 1) {
                // Keep field from first occurrence
                // Future: Can append page suffix if needed
                // fieldKey = `${fieldKey}_page_${docIndex + 1}`
                console.log(`⏭️ AnalyzeExpense: Skipping duplicate summary field "${fieldKey}" from page ${docIndex + 1} (already exists from page ${properties[fieldKey].page})`)
                return
              }

              properties[fieldKey] = {
                type: 'string',
                value: field.ValueDetection?.Text || '',
                confidence: field.ValueDetection?.Confidence || 0,
                instruction: `Extract ${field.Type?.Text || fieldKey} from page ${docIndex + 1}`,
                page: field.PageNumber || docIndex + 1,
                boundingBox: field.ValueDetection?.Geometry?.BoundingBox,
                isEditing: false,
              }
              summaryFieldCounter++
            })

            // Extract line items in structured format from all pages
            // Each LineItemGroup represents a separate table
            expenseDoc.LineItemGroups?.forEach((group, tableIndex) => {
              group.LineItems?.forEach((lineItem, itemIndex) => {
                const lineItemObj = {
                  pageIndex: docIndex,
                  pageNumber: docIndex + 1,
                  tableIndex: tableIndex, // Unique table identifier
                  tableName: `table_${docIndex + 1}_${tableIndex + 1}`, // e.g., table_1_1, table_1_2
                  lineNumber: itemIndex + 1,
                  fields: {},
                }

                lineItem.LineItemExpenseFields?.forEach((field) => {
                  const fieldType = field?.LabelDetection?.Text
                  if (fieldType) {
                    const fieldTypeKey = fieldType.toLowerCase().replace(/\s+/g, '_')

                    const fieldData = {
                      type: 'string',
                      value: field.ValueDetection?.Text || '',
                      confidence: field.ValueDetection?.Confidence || 0,
                      instruction: `Extract line item ${fieldType} from ${lineItemObj.tableName}`,
                      page: field.PageNumber || docIndex + 1,
                      boundingBox: field.ValueDetection?.Geometry?.BoundingBox,
                      isEditing: false,
                    }
                    // Add to structured line item
                    lineItemObj.fields[fieldTypeKey] = fieldData
                  }
                })

                lineItems.push(lineItemObj)
              })
            })
          })

          // Group line items by table for logging
          const tableGrouping = {}
          lineItems.forEach((item) => {
            if (!tableGrouping[item.tableName]) {
              tableGrouping[item.tableName] = 0
            }
            tableGrouping[item.tableName]++
          })
          console.log(`Processed ${textractResponse.ExpenseDocuments.length} pages with ${summaryFieldCounter} summary fields and ${lineItems.length} total line items`)

          // Group line items by table for proper separation
          const tables = []
          const tableMap = new Map()

          lineItems.forEach((item) => {
            const tableKey = item.tableName
            if (!tableMap.has(tableKey)) {
              tableMap.set(tableKey, {
                tableName: item.tableName,
                tableIndex: item.tableIndex,
                pageNumber: item.pageNumber,
                pageIndex: item.pageIndex,
                lineItems: [],
              })
              tables.push(tableMap.get(tableKey))
            }
            tableMap.get(tableKey).lineItems.push(item)
          })

          // Store structured data with separated tables
          if (!textractResponse._structuredData) {
            textractResponse._structuredData = {}
          }
          textractResponse._structuredData.tables = tables
          textractResponse._structuredData.lineItems = lineItems // Keep for backward compatibility
          textractResponse._structuredData.pageCount = textractResponse.ExpenseDocuments.length

          console.log(
            `Created ${tables.length} separate tables:`,
            tables.map((t) => `${t.tableName} (${t.lineItems.length} items)`)
          )
          textractResponse._structuredData.pageCount = textractResponse.ExpenseDocuments.length
        }
        break

      case 'AnalyzeID':
        // Extract ID document fields from Textract - handle multipage
        // Note: AnalyzeID response doesn't include geometry in IdentityDocumentFields
        // We need to extract bounding boxes from the Blocks array
        if (textractResponse.IdentityDocuments && textractResponse.IdentityDocuments.length > 0) {
          // Process ALL ID documents (all pages)
          textractResponse.IdentityDocuments.forEach((idDoc, docIndex) => {
            idDoc.IdentityDocumentFields?.forEach((field) => {
              const fieldKey = (field.Type?.Text || 'field').toLowerCase().replace(/\s+/g, '_')
              const fieldValue = field.ValueDetection?.Text || ''

              // If field already exists and from different page, ignore it and continue
              if (properties[fieldKey] && properties[fieldKey].page !== docIndex + 1) {
                // Keep field from first occurrence
                // Future: Can append page suffix if needed
                // fieldKey = `${fieldKey}_page_${docIndex + 1}`
                console.log(`⏭️ AnalyzeID: Skipping duplicate field "${fieldKey}" from page ${docIndex + 1} (already exists from page ${properties[fieldKey].page})`)
                return
              }

              // Extract bounding box from Blocks array by matching the value text
              const boundingBox = extractBoundingBoxFromBlocks(idDoc.Blocks, fieldValue)

              properties[fieldKey] = {
                type: 'string',
                value: fieldValue,
                confidence: field.ValueDetection?.Confidence || 0,
                instruction: `Extract ${field.Type?.Text || fieldKey} from page ${docIndex + 1}`,
                page: docIndex + 1,
                boundingBox: boundingBox,
                isEditing: false,
              }
            })
          })
        }
        console.log(`✅ AnalyzeID: Extracted ${Object.keys(properties).length} fields from ${textractResponse.IdentityDocuments?.length || 0} ID documents`)
        break

      case 'AnalyzeLending':
        // Extract lending document fields from Textract - handle multipage
        if (textractResponse.Results && textractResponse.Results.length > 0) {
          textractResponse.Results.forEach((result, resultIndex) => {
            result.Extractions?.forEach((extraction) => {
              const pageNumber = extraction.LendingDocument?.PageNumber || resultIndex + 1
              if (extraction.LendingDocument?.LendingFields) {
                extraction.LendingDocument.LendingFields.forEach((field) => {
                  const fieldKey = (field.Type || `field_${resultIndex}`).toLowerCase().replace(/\s+/g, '_')

                  // If field already exists and from different page, ignore it and continue
                  if (properties[fieldKey] && properties[fieldKey].page !== pageNumber) {
                    // Keep field from first occurrence
                    // Future: Can append page suffix if needed
                    // fieldKey = `${fieldKey}_page_${pageNumber}`
                    console.log(`⏭️ AnalyzeLending: Skipping duplicate field "${fieldKey}" from page ${pageNumber} (already exists from page ${properties[fieldKey].page})`)
                    return
                  }

                  properties[fieldKey] = {
                    type: 'string',
                    value: field.ValueDetections?.[0]?.Text || '',
                    confidence: field.ValueDetections?.[0]?.Confidence || 0,
                    instruction: `Extract ${field.Type || fieldKey} from page ${pageNumber}`,
                    page: pageNumber,
                    boundingBox: field.ValueDetections?.[0]?.Geometry?.BoundingBox,
                    isEditing: false,
                  }
                })
              }
            })
          })
        }
        console.log(`✅ AnalyzeLending: Extracted ${Object.keys(properties).length} fields from ${textractResponse.Results?.length || 0} results`)
        break

      default:
        console.warn('⚠️ Unknown analysis type:', analysisType)
    }

    // Create explainability info for visualization
    explainabilityInfo = Object.entries(properties).map(([key, value]) => ({
      field: key,
      confidence: value.confidence,
      page: value.page,
      boundingBox: value.boundingBox,
    }))

    // Debug: Log first few items to verify bounding boxes are included
    console.log('📊 Explainability Info Sample (first 3 items):', explainabilityInfo.slice(0, 3))
  } catch (error) {
    console.error('❌ Error transforming Textract response:', error)
  }

  console.log('✅ Transformed properties:', Object.keys(properties).length, 'fields')

  const result = {
    blueprintArn: jobId || textractResponse.JobId || `textract_${Date.now()}`, // Use Job ID as ARN equivalent
    blueprintSchema: {
      class: documentName || 'textract_document',
      properties: properties,
    },
    finalResult: {
      explainability_info: [explainabilityInfo],
      raw_textract_response: textractResponse,
      analysis_type: analysisType,
      extracted_fields_count: Object.keys(properties).length,
    },
  }

  // Add structured data for AnalyzeExpense
  if (analysisType === 'AnalyzeExpense') {
    // Use separated tables if available, fallback to flat lineItems for backward compatibility
    if (textractResponse._structuredData?.tables && textractResponse._structuredData.tables.length > 0) {
      result.finalResult.tables = textractResponse._structuredData.tables
      console.log(`📊 AnalyzeExpense: Added ${textractResponse._structuredData.tables.length} separated tables to finalResult`)
    } else if (textractResponse._structuredData?.lineItems) {
      result.finalResult.lineItems = textractResponse._structuredData.lineItems
    }
  }

  return result
}

/**
 * Helper function to extract key-value pairs from Textract blocks
 */
function extractKeyValuePairs(blocks) {
  const keyValuePairs = []
  const keyMap = {}
  const valueMap = {}
  const blockMap = {}

  // Build a map of all blocks
  blocks.forEach((block) => {
    blockMap[block.Id] = block

    if (block.BlockType === 'KEY_VALUE_SET') {
      if (block.EntityTypes?.includes('KEY')) {
        keyMap[block.Id] = block
      } else if (block.EntityTypes?.includes('VALUE')) {
        valueMap[block.Id] = block
      }
    }
  })

  // Match keys with values
  Object.values(keyMap).forEach((keyBlock) => {
    const valueRelationship = keyBlock.Relationships?.find((rel) => rel.Type === 'VALUE')
    if (valueRelationship && valueRelationship.Ids?.length > 0) {
      const valueId = valueRelationship.Ids[0]
      const valueBlock = valueMap[valueId]

      if (valueBlock) {
        const keyText = getTextFromBlock(keyBlock, blockMap)
        const valueText = getTextFromBlock(valueBlock, blockMap)

        keyValuePairs.push({
          key: keyText || 'unknown_field',
          value: valueText || '',
          confidence: Math.min(keyBlock.Confidence || 0, valueBlock.Confidence || 0),
          page: keyBlock.Page || 1,
          boundingBox: valueBlock?.Geometry?.BoundingBox || keyBlock?.Geometry?.BoundingBox,
        })
      }
    }
  })

  return keyValuePairs
}

/**
 * Helper function to get text from a Textract block
 */
function getTextFromBlock(block, blockMap) {
  if (block.Text) {
    return block.Text
  }

  // If no direct text, try to get from child blocks
  const childRelationship = block.Relationships?.find((rel) => rel.Type === 'CHILD')
  if (childRelationship && childRelationship.Ids) {
    const childTexts = childRelationship.Ids.map((id) => blockMap[id]?.Text).filter((text) => text)
    return childTexts.join(' ')
  }

  return ''
}

// ==================== TEXTRACT UPLOAD FUNCTION ====================
/**
 * Handles file upload and processing for Textract
 * Similar to uploadFileToS3 but calls Textract APIs instead of Bedrock
 */
async function uploadFileWithTextract(file) {
  console.log('📤 Starting Textract upload flow')
  const tenantId = Number(route.query.tenant_id)
  finalResult.value = []

  // Validate Textract-specific requirements
  if (!textractAnalysisType.value) {
    showTextractError.value = true
    showPopup(t('documentTraining.analysisTypeRequired') || 'Please select an analysis type', t('common.error'))
    return
  }

  // For new document flow, process manual input name same way as displayName
  if (isNewDocumentFlow.value && manualDocumentTypeName.value) {
    const timestamp = Date.now()
    const sanitizedName = manualDocumentTypeName.value.replace(/\s+/g, '_')
    blueprintName.value = `${tenantId}_${timestamp}_${sanitizedName}`
  } else {
    showPopup(t('uploads.validation.name_required_edit_mode'), t('common.error'))
    return
  }

  fileUploading.value = true

  try {
    if (!file) {
      showPopup(t('uploads.errors.missing_file_or_project'), t('common.error'))
      return
    }

    // File validation (same as Bedrock)
    const invalidCharPattern = /[\x00-\x1F\x7F{}[\]^%`"~<>|#]/g
    const matches = file.name.match(invalidCharPattern)
    if (matches) {
      const uniqueChars = [...new Set(matches)].join(' ')
      showPopup(`Invalid characters found in selected file name: ${uniqueChars}`, 'File Name Validation Error')
      return
    }

    const fileSizeMB = file.size / (1024 * 1024)
    if (fileSizeMB > 5) {
      showPopup(t('uploads.errors.file_size_too_large'), t('common.error'))
      return
    }

    // Process file to create document array (same as Bedrock)
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      uploadedFilePagesCount.value = 1
      docArray.value = await convertJpegToImageArray(file)
    } else if (file.type === 'application/pdf') {
      try {
        const pageCount = await getPdfPageCount(file)
        if (pageCount > 10) {
          showPopup(t('uploads.errors.pdf_too_many_pages'), t('common.error'))
          return
        }
        docArray.value = await convertPdfToImageArray(file)
      } catch (err) {
        showPopup(err?.message || 'Could not read the PDF file.', 'Error Reading File')
        return
      }
    } else if (file.type === 'image/tiff' || file.name.endsWith('.tif')) {
      try {
        const count = await getTiffPageCount(file)
        if (count > 10) {
          showPopup(t('uploads.errors.tiff_too_many_pages'), t('common.error'))
          return
        }
        docArray.value = await convertTiffToImageArray(file)
      } catch (err) {
        showPopup(err?.message || 'Could not read the TIFF file.', 'Error Reading File')
        return
      }
    }

    // Validate blueprint name
    const isValidName = /^[a-zA-Z0-9-_]+$/.test(blueprintName.value)
    if (!isValidName) {
      showPopup(t('uploads.validation.name_invalid_characters'), t('common.error'))
      return
    }

    // Step 1: Upload file to S3
    messages.value = t('documentTraining.readingFile')
    const base64 = await readFileAsBase64(file)

    messages.value = t('documentTraining.uploading')
    try {
      const { s3Url, httpsUrl } = await uploadToApi(base64, file.name, file.type)
      fileS3Url.s3Url = s3Url
      fileS3Url.httpsUrl = httpsUrl
      console.log('✅ File uploaded to S3:', s3Url)
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.upload_failed'), t('uploads.errors.failed_to_upload'))
      return
    }

    // Step 2: Call Textract API to analyze document
    messages.value = 'Analyzing document with Textract...'
    console.log('📋 Calling Textract API with analysis type:', textractAnalysisType.value)

    let textractResponse
    try {
      const analyzeRes = await post(`/v1/textract/analyze`, {
        s3Url: fileS3Url.s3Url,
        analysisType: textractAnalysisType.value,
        tenantId: tenantId,
        documentName: blueprintName.value,
      })

      textractResponse = analyzeRes.data
      console.log('✅ Textract analysis complete:', textractResponse)

      if (!textractResponse || textractResponse.error) {
        throw new Error(textractResponse?.error || 'Textract analysis failed')
      }
    } catch (error) {
      console.error('❌ Textract analysis error:', error)
      showPopup(error?.message || 'Failed to analyze document with Textract', 'Textract Analysis Error')
      return
    }

    messages.value = 'Processing extracted data...'

    // Step 3: Transform Textract response to Bedrock format
    console.log('🔄 Transforming Textract response to Bedrock format')
    console.log('📦 Full response structure:', textractResponse)

    // Extract the actual Textract result from the API response
    // API returns: { code, message, jobId, analysisType, result: {...} }
    const actualTextractResult = textractResponse.result || textractResponse
    console.log('📦 Actual Textract result:', actualTextractResult)

    const transformedData = transformTextractResponseToBedrockFormat(
      actualTextractResult,
      textractAnalysisType.value,
      blueprintName.value,
      textractResponse.jobId // Pass jobId from API wrapper
    )

    // Set the transformed data to component state
    // blueprintArn.value = transformedData.blueprintArn
    blueprintArn.value = textractAnalysisType.value
    blueprintSchema.value = transformedData.blueprintSchema
    finalResult.value = transformedData.finalResult

    console.log('✅ Data transformation complete')
    console.log('Blueprint Schema:', blueprintSchema.value)
    console.log('Final Result:', finalResult.value)

    messages.value = t('documentTraining.extractionComplete')

    // Step 4: Create draft document
    console.log('=== CALLING CREATE DRAFT DOCUMENT ===')
    const documentTypeId = await createDraftDocument()

    if (documentTypeId) {
      console.log('✅ Draft document created with ID:', documentTypeId)

      // Update URL with document_type_id
      const currentQuery = { ...route.query }
      const newQuery = { ...currentQuery, document_type_id: documentTypeId }

      router.replace({ query: newQuery })
      sessionStorage.setItem('current_document_type_id', String(documentTypeId))

      // CRITICAL FIX: Set isEditFlow flag for Textract flow as well
      isEditFlow.value = true
      console.log('✅ [Textract] isEditFlow set to true - subsequent steps will use edit/update mode')
    } else {
      console.error('❌ Draft document creation failed')
    }

    // Step 5: Move to preview step
    showExtractionData.value = true
    step.value = 'preview'
    console.log('✅ Textract upload flow complete, moving to preview')
  } catch (error) {
    console.error('❌ Textract upload error:', error)
    showPopup(error?.message || 'Unknown error during Textract upload', 'Error')
    blueprintSchema.value = null
  } finally {
    fileUploading.value = false
  }
}

// ==================== MAIN UPLOAD ROUTER ====================
/**
 * Main upload function that routes to appropriate handler based on AI method
 */
async function uploadFileToS3(file) {
  if (existingDocumentTypeName?.value?.includes(manualDocumentTypeName.value)) {
    showTextractError.value = true
    showPopup('Document type name already exists. Please choose a different name.')
    return
  }
  // Route to Textract handler if tenant uses Textract
  if (selectedTenantUsesTextract.value && isTextractFlow.value) {
    console.log('🔀 Routing to Textract upload handler')
    return await uploadFileWithTextract(file)
  }

  // Otherwise use Bedrock flow (default)
  console.log('🔀 Routing to Bedrock upload handler')
  return await uploadFileWithBedrock(file)
}

// ==================== BEDROCK UPLOAD FUNCTION ====================
/**
 * Original Bedrock upload function (renamed from uploadFileToS3)
 */
async function uploadFileWithBedrock(file) {
  console.log('📤 Starting Bedrock upload flow')
  const tenantId = Number(route.query.tenant_id)
  finalResult.value = []
  let schemaJson, blueprintData, finalStatus, finalJson, s3Url, httpsUrl

  // For new document flow, process manual input name same way as displayName
  if (isNewDocumentFlow.value && manualDocumentTypeName.value) {
    const timestamp = Date.now()
    // Replace spaces with underscores for S3 upload
    const sanitizedName = manualDocumentTypeName.value.replace(/\s+/g, '_')
    blueprintName.value = `${tenantId}_${timestamp}_${sanitizedName}`
  } else {
    showPopup(t('uploads.validation.name_required_edit_mode'), t('common.error'))
    return
  }
  fileUploading.value = true
  try {
    if (!file || !projectArn) {
      showPopup(t('uploads.errors.missing_file_or_project'), t('common.error'))
      return
    }

    // check if the file name is valid
    // Define invalid characters (based on Bedrock's spec)
    // eslint-disable-next-line no-control-regex
    const invalidCharPattern = /[\x00-\x1F\x7F{}[\]^%`"~<>|#]/g // Control chars and invalid filename chars
    const matches = file.name.match(invalidCharPattern)

    if (matches) {
      const uniqueChars = [...new Set(matches)].join(' ')
      showPopup(`Invalid characters found in selected file name: ${uniqueChars}`, 'File Name Validation Error')
      return
    }
    const fileSizeMB = file.size / (1024 * 1024)
    if (fileSizeMB > 5) {
      showPopup(t('uploads.errors.file_size_too_large'), t('common.error'))
      return
    }

    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      uploadedFilePagesCount.value = 1
      docArray.value = await convertJpegToImageArray(file)
    } else if (file.type === 'application/pdf') {
      try {
        const pageCount = await getPdfPageCount(file)
        if (pageCount > 10) {
          showPopup(t('uploads.errors.pdf_too_many_pages'), t('common.error'))
          return
        }
        docArray.value = await convertPdfToImageArray(file)
      } catch (err) {
        showPopup(err?.message || 'Could not read the PDF file.', 'Error Reading File')
        return
      }
    } else if (file.type === 'image/tiff' || file.name.endsWith('.tif')) {
      try {
        const count = await getTiffPageCount(file)
        if (count > 10) {
          showPopup(t('uploads.errors.tiff_too_many_pages'), t('common.error'))
          return
        }
        docArray.value = await convertTiffToImageArray(file)
      } catch (err) {
        showPopup(err?.message || 'Could not read the TIFF file.', 'Error Reading File')
        return
      }
    }

    const isValidName = /^[a-zA-Z0-9-_]+$/.test(blueprintName.value)
    if (!isValidName) {
      showPopup(t('uploads.validation.name_invalid_characters'), t('common.error'))
      return
    }

    // if (blueprintNames.value?.some((blueprint) => blueprint.BlueprintName === blueprintName.value)) {
    //   showPopup('Document Type name already exist', 'Document Type Name Validation Error')
    //   return
    // }

    messages.value = t('documentTraining.readingFile')
    const base64 = await readFileAsBase64(file)

    messages.value = t('documentTraining.uploading')
    try {
      const { s3Url, httpsUrl } = await uploadToApi(base64, file.name, file.type)
      fileS3Url.s3Url = s3Url
      fileS3Url.httpsUrl = httpsUrl
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.upload_failed'), t('uploads.errors.failed_to_upload'))
      return
    }
    messages.value = t('documentTraining.fileUploaded')
    messages.value = t('documentTraining.generatingSchema')

    try {
      schemaJson = await getSchemaFromLLM(fileS3Url.s3Url)
      if (schemaJson.success === false) {
        showPopup(schemaJson.error, schemaJson.title)
        return
      }
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.extraction_failed'), t('uploads.errors.failed_to_start_extraction'))
      return
    }

    try {
      // Use the class name from the schema that was generated, not the blueprintName
      const schemaClass = schemaJson.schema.class || blueprintName.value
      const payload = {
        blueprintName: blueprintName.value,
        // Keep the original class from schema generation, don't override it
        schemaString: JSON.stringify(schemaJson.schema),
        schema: JSON.stringify(schemaJson.schema),
        s3Uri: fileS3Url.s3Url,
        sourceFileName: file.name,
        s3Url: fileS3Url.httpsUrl,
        tenantId: tenantId,
      }
      const blueprintRes = await post(`/v1/bedrock/create-blueprint`, payload)
      blueprintData = blueprintRes.data
      blueprintArn.value = blueprintData.blueprintArn
    } catch (error) {
      showPopup(error?.message.replaceAll('Blueprint', 'Document type') || 'Unknown error while creating blueprint', 'Failed To Create Document Type')
      return
    }

    // try {
    //   const moveToProjectRes = await fetch(`${baseURL}/api/update-project`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       blueprintArn: blueprintData.blueprintArn,
    //       projectArn: projectArn,
    //     }),
    //   })
    //   // Check response.ok BEFORE parsing JSON
    //   if (!moveToProjectRes.ok) {
    //     const errorText = await moveToProjectRes.text() // This works on Response
    //     throw new Error(errorText)
    //   }
    //   await moveToProjectRes.json() // Response processed successfully
    // } catch (error) {
    //   showPopup(error?.message || 'Failed to update project', 'Failed To Update Project')
    //   return
    // }

    messages.value = t('documentTraining.runningExtraction')
    let result
    try {
      const finalInvokeRes = await post(`/v1/bedrock/invoke-bda`, {
        s3Url: fileS3Url.s3Url,
        projectArn: projectArn,
        blueprintArn: blueprintData?.blueprintArn,
        stage: 'TEST',
        tenantId: Number(tenantId),
      })

      result = finalInvokeRes.data
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.extraction_failed'), t('uploads.errors.failed_to_start_extraction'))
      return
    }
    if (tenantDocumentType?.value?.data) {
      // Use the class from the generated schema
      tenantDocumentType.value.data = {
        ...tenantDocumentType.value.data,
        bda_blueprint: blueprintData?.blueprintArn,
        bedrock_class_name: schemaJson.schema.class || blueprintName.value, // Use schema class or fallback
        bda_invocation_arn: result?.invocationArn,
      }
      // console.log('updatedtenantDocumentTypeRes 1', tenantDocumentType.value?.data)
      const tenantDocumentTypeRes = await put(`/v1/tenant-document-types/${route.query.document_type_id}`, tenantDocumentType.value.data)
    }

    try {
      finalStatus = await pollForStatus(result.invocationArn)
      if (!finalStatus || finalStatus.status !== 'Success') {
        messages.value = `Final extraction failed: ${finalStatus?.status || 'Unknown'}`
        return
      }
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.extraction_failed'), t('uploads.errors.failed_to_check_status'))
      return
    }

    messages.value = t('documentTraining.retrievingData')
    // const finalJsonUrl = finalStatus.outputUri.replace('/job_metadata.json', '/0/custom_output/0/result.json')

    try {
      const finalJsonRes = await get(`/v1/bedrock/get-result-output?invocationArn=${result.invocationArn}&tenantId=${Number(tenantId)}`)
      finalJson = finalJsonRes.data
      // Update the tenantDocumentType data with new values
    } catch (error) {
      showPopup(error?.message || t('uploads.errors.extraction_failed'), t('uploads.errors.failed_to_get_output'))
      return
    }
    messages.value = t('documentTraining.extractionComplete')

    const finalExtractedData = await mergeExplainabilityInfo(schemaJson.schema, finalJson?.explainability_info[0])
    const payloadPut = {
      blueprintArn: blueprintData.blueprintArn,
      // Keep the original class from schema generation
      schema: JSON.stringify(schemaJson.schema),
      finalResult: finalJson,
    }
    // Keep original class from schema - don't override
    await put(`/v1/bedrock/update-blueprint`, payloadPut)
    blueprintSchema.value = finalExtractedData
    // Add invocationArn to finalResult so DocumentPreview knows we already invoked
    finalResult.value = {
      ...finalJson,
      invocationArn: result.invocationArn,
    }

    // Create draft document after we have all final results (ideal flow)
    console.log('=== CALLING CREATE DRAFT DOCUMENT ===')
    const documentTypeId = await createDraftDocument()
    console.log('=== CREATE DRAFT DOCUMENT RESULT ===')
    console.log('Returned documentTypeId:', documentTypeId)
    console.log('Type of documentTypeId:', typeof documentTypeId)
    console.log('Is truthy?', !!documentTypeId)

    if (documentTypeId) {
      console.log('✅ Draft document created with ID:', documentTypeId)

      // Update the URL to include the document_type_id for subsequent steps
      const currentQuery = { ...route.query }
      const newQuery = { ...currentQuery, document_type_id: documentTypeId }

      console.log('Current route query:', currentQuery)
      console.log('New route query:', newQuery)

      router.replace({ query: newQuery })
      sessionStorage.setItem('current_document_type_id', String(documentTypeId))

      // CRITICAL FIX: Set isEditFlow flag so subsequent steps treat this as edit mode
      // This ensures data is saved correctly using update APIs instead of create APIs
      isEditFlow.value = true
      console.log('✅ isEditFlow set to true - subsequent steps will use edit/update mode')

      // Verify updates
      console.log('Session storage current_document_type_id set to:', sessionStorage.getItem('current_document_type_id'))
      console.log('Route should now have document_type_id:', route.query.document_type_id)
    } else {
      console.error('❌ Draft document creation failed - documentTypeId is null/undefined')
    }
    console.log('=== END DRAFT DOCUMENT CREATION ===')

    showExtractionData.value = true
    step.value = 'preview'
  } catch (error) {
    showPopup(error?.message || 'Unknown error', 'Error')
    blueprintSchema.value = null
  } finally {
    // existingBlueprintsNames.value = await fetchBlueprintNames(
    //   projectArn
    //   // liveProjectArn
    // )
    fileUploading.value = false
  }
}

// Create a draft document when DocumentPreview step is completed
const createDraftDocument = async () => {
  try {
    // Only create draft if we're not in edit mode (edit mode already has a document_type_id)
    if (isEditFlow.value) {
      console.log('Edit flow detected, skipping draft creation as document type already exists')
      return null
    }

    const tenantId = route.query.tenant_id
    if (!tenantId) {
      console.warn('No tenant_id found in URL, skipping draft creation')
      return null
    }

    // Validate that we have a blueprintArn - it's required by the backend
    if (!blueprintArn.value || blueprintArn.value === '') {
      console.warn('Cannot create draft: blueprintArn is not available. This might be too early in the flow.')
      console.log('Current state:', {
        blueprintArn: blueprintArn.value,
        blueprintName: blueprintName.value,
        hasSchema: !!blueprintSchema.value,
      })
      return null
    }

    // Get the class name from the schema, fallback to blueprint name
    const className = blueprintSchema.value?.class || blueprintName.value?.toLowerCase().replace(/\s+/g, '_') || 'document'

    const draftData = {
      docPreviewData: {
        blueprintArn: blueprintArn.value || '',
        blueprintSchema: blueprintSchema.value || {},
        blueprintName: blueprintName.value || 'Document',
        documentTypeName: getDocumentTypeName(),
        finalResult: finalResult.value || {},
        invocationArn: finalResult.value?.invocationArn || '', // Now available since BDA is complete
        s3_uri: fileS3Url?.s3Url || '',
        s3_url: fileS3Url?.httpsUrl || '',
      },
      tenantId: parseInt(tenantId),
      userId: JSON.parse(localStorage.getItem('UserData'))?.id || 1, // Get user ID from localStorage or default to 1
      source_file_name: selectedFile.value?.name,
      uploaded_file_pages_count: uploadedFilePagesCount.value,
    }

    console.log('Creating draft document with payload:', draftData)
    console.log('Detailed draft data structure:', {
      docPreviewData: draftData.docPreviewData,
      tenantId: draftData.tenantId,
      userId: draftData.userId,
      source_file_name: draftData.source_file_name,
    })

    // Call the appropriate API endpoint based on tenant's AI method
    const apiEndpoint = selectedTenantUsesTextract.value ? '/v1/textract/create-draft' : '/v1/bedrock/create-draft'
    console.log('Calling create-draft endpoint:', apiEndpoint)
    const response = await post(apiEndpoint, draftData)

    console.log('=== DRAFT CREATION RESPONSE DEBUG ===')
    console.log('Full response:', response)
    console.log('Response data:', response?.data)
    console.log('Response data.data:', response?.data?.data)
    console.log('Document type ID path:', response?.data?.data?.document_type_id)
    console.log('=== END DRAFT CREATION RESPONSE DEBUG ===')

    if (response?.data?.data?.document_type_id) {
      console.log('✅ Draft created successfully with ID:', response.data.data.document_type_id)
      showToast({
        title: t('documentTraining.successMessages.draft_saved_successfully_title'),
        message: t('documentTraining.successMessages.draft_saved_successfully_message'),
        type: 'info',
      })
      return response.data.data.document_type_id
    } else if (response?.data) {
      console.error('❌ Draft creation response missing document_type_id:', response.data)
    }

    return null
  } catch (error) {
    console.error('Error creating draft document:', error)
    // Don't throw error - allow flow to continue without draft creation
    showPopup(`Could not save draft: ${error.message}. You can continue with the flow.`, 'Draft Creation Warning')
    return null
  }
}

const handlePreview = (invocationArn) => {
  // Store document preview data for both Bedrock and Textract flows
  if (selectedTenantUsesBedrock.value) {
    collectedStepData.value.docPreviewData = {
      blueprintArn: blueprintArn.value,
      blueprintSchema: blueprintSchema.value,
      blueprintName: blueprintName.value,
      finalResult: finalResult.value,
      invocationArn: invocationArn, // Pass the invocation ARN
    }
  } else if (selectedTenantUsesTextract.value) {
    // For Textract, also populate docPreviewData
    collectedStepData.value.docPreviewData = {
      blueprintArn: blueprintArn.value,
      blueprintSchema: blueprintSchema.value,
      blueprintName: blueprintName.value,
      finalResult: finalResult.value,
      invocationArn: invocationArn || '', // Textract may not have invocation ARN
      s3_uri: fileS3Url.s3Url || '',
      s3_url: fileS3Url.httpsUrl || '',
    }
  }

  // Draft document was already created during file upload,
  // so we just move to the next step
  step.value = 'fieldMapping'
}

const handleDisplayNameChange = (newName) => {
  // In edit mode, don't let DocumentPreview overwrite the API-fetched editableDisplayName
  // unless the current editableDisplayName is empty or we explicitly want to change it
  if (isEditFlow.value && editableDisplayName.value) {
    console.log('📝 Ignoring displayNameChange in edit mode. Current:', editableDisplayName.value, 'Attempted:', newName)
    return
  }

  console.log('📝 Updating editableDisplayName from DocumentPreview:', newName)
  editableDisplayName.value = newName
}

const handleFieldMapping = (data) => {
  // Store extraction mapping data for both Bedrock and Textract flows
  if ((selectedTenantUsesBedrock.value || selectedTenantUsesTextract.value) && data) {
    if (data.extractionMappingList) {
      // CRITICAL FIX: Merge existing field mappings with new ones instead of overwriting
      // This ensures we don't lose field mappings that were not loaded in the current session
      // Create a map of field IDs from the new data for quick lookup
      const newFieldIds = new Set(data.extractionMappingList.map((field) => field.id))

      // Start with existing mappings, but exclude any that are being updated
      const existingMappingsToKeep = (collectedStepData.value.extractionMappingList || []).filter((existingField) => {
        const shouldKeep = !newFieldIds.has(existingField.id)
        if (!shouldKeep) {
          console.log(`Replacing existing mapping for field '${existingField.vasion_field_name}' (ID: ${existingField.id})`)
        } else {
          console.log(`Keeping existing mapping for field '${existingField.vasion_field_name}' (ID: ${existingField.id})`)
        }
        return shouldKeep
      })

      // Merge existing mappings (that weren't updated) with new mappings
      const mergedMappings = [...existingMappingsToKeep, ...data.extractionMappingList]
      // Update with merged mappings instead of overwriting
      collectedStepData.value.extractionMappingList = mergedMappings
      // ENHANCEMENT: Also store in BDAExtraction persistence data
      collectedStepData.value.bdaExtractionData.extractionMappingList = mergedMappings
    }
    if (data.vasionFormId) {
      collectedStepData.value.vasionFormId = data.vasionFormId
      // ENHANCEMENT: Also store in BDAExtraction persistence data
      collectedStepData.value.bdaExtractionData.selectedVasionFormId = data.vasionFormId
    }
    // Store edited document type name if provided
    if (data.editedDocumentTypeName) {
      editableDisplayName.value = data.editedDocumentTypeName
      console.log('Updated document type name from BDAExtraction:', data.editedDocumentTypeName)
    }
  }
  step.value = 'allset'
}

const handleCompletion = (payload) => {
  // Persist document type ID in URL (and session) when available
  const docTypeId = payload?.documentTypeId
  if (docTypeId) {
    sessionStorage.setItem('document_type_id', String(docTypeId))
    const newQuery = { ...route.query, document_type_id: docTypeId }
    router.replace({ query: newQuery })
  }
  // Since ConfigureVasionSettings handles the loading state internally, navigate immediately
  const tenantName = localStorage.getItem('url_name')
  router.push(`/${tenantName}/configure/document-types`)
}

function setBlueprintSchema(val) {
  // If val is a stringified JSON, parse it
  let schemaObj = typeof val === 'string' ? JSON.parse(val) : val

  // Set the class property in the schema to the selected class name (from classSelectionMode)
  if (classSelectionMode.value) {
    schemaObj.class = classSelectionMode.value
  }
  blueprintSchema.value = schemaObj
}

function setFinalResult(val) {
  finalResult.value = val
}

function toggleCreateNew() {
  isCreatingNew.value = true
  classSelectionMode.value = ''
  newClass.name = ''
  // Reset any existing errors
  showErrors.value = false
}

function cancelCreateNew() {
  isCreatingNew.value = false
  newClass.name = ''
}

function onClassSelectionChange() {
  if (classSelectionMode.value) {
    newClass.name = classSelectionMode.value
  } else {
    newClass.name = ''
  }
}

// Add this new function to fetch classes
async function fetchClasses() {
  classesLoading.value = true
  try {
    // Using the same API pattern as other calls in this file
    // const userData = JSON.parse(localStorage.getItem('UserData'))
    const tenantId = Number(route.query.tenant_id)
    let url = `/v1/bedrock/list-bda-classes?tenantId=${tenantId}`
    const response = await get(url)

    if (response?.status === 200) {
      classes.value = response.data
    }
  } catch (error) {
  } finally {
    classesLoading.value = false
  }
}

// Function to get document type name for display
function getDocumentTypeName() {
  if (manualDocumentTypeName.value) {
    return manualDocumentTypeName.value
  } else if (editableDisplayName.value) {
    return editableDisplayName.value
  }
  return t('uploads.new_document_type')
}

// Function to handle state changes from ConfigureVasionSettings component
function handleVasionSettingsStateChange(data) {
  console.log('Handling VasionSettings state change:', data)
  if (data.vasionSettingsData) {
    collectedStepData.value.vasionSettingsData = { ...collectedStepData.value.vasionSettingsData, ...data.vasionSettingsData }
    console.log('Updated vasionSettingsData in collectedStepData:', collectedStepData.value.vasionSettingsData)
  }
}

// Function to handle back navigation
function goBack() {
  const tenantName = localStorage.getItem('url_name')
  // If we're in edit flow, go back to document types page
  if (step.value === 'preview') {
    router.push(`/${tenantName}/configure/document-types`)
  } else if (step.value === 'fieldMapping') {
    step.value = 'preview'
  } else if (step.value === 'allset') {
    console.log('🔙 Uploads: Going back from allset to fieldMapping')
    console.log('💾 Uploads: collectedStepData.bdaExtractionData.extractionMappingList count:', collectedStepData.value.bdaExtractionData.extractionMappingList?.length || 0)
    console.log('💾 Uploads: Sample mapping data:', collectedStepData.value.bdaExtractionData.extractionMappingList?.slice(0, 3))
    step.value = 'fieldMapping'
  } else {
    router.push(`/${tenantName}/configure/document-types`)
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;600;700&display=swap');

.uploads-container {
  background: var(--secondary-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  /* max-height: 50vh !important; */
  /* margin-bottom: -200px; */
}

.upload-card {
  max-width: 580px;
  width: 100%;
  margin: 0 auto;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 4px 32px 0 #b6e1fb40;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 1.5px solid #deecf7;
}

.upload-card h2 {
  margin-bottom: 25px;
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--primary-color);
  text-align: center;
  letter-spacing: 0.03em;
}

.header-title-custom {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--primary-color);
  text-align: center;
  letter-spacing: 0.03em;
}

.upload-label {
  margin-bottom: 20px;
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--primary-color);
  text-align: center;
  line-height: 1.5;
  font-family: 'Lato', sans-serif;
  opacity: 0.9;
}

.error-message {
  color: #d61b1b;
  font-size: 0.9rem;
  margin-bottom: 15px;
  padding: 8px 12px;
  background-color: #ffeaea;
  border: 1px solid #ffcccc;
  border-radius: 6px;
  font-family: 'Lato', sans-serif;
  line-height: 1.4;
  /* margin-left: -15px; */
}

.input-label {
  margin-bottom: 10px;
  color: var(--primary-color);
  font-weight: 600;
  font-size: 1.06rem;
}

.text-input {
  padding: 13px 14px;
  font-size: 1rem;
  border: 1.5px solid var(--primary-color);
  border-radius: 9px;
  margin-bottom: 20px;
  outline: none;
  background: var(--secondary-color);
  transition: border 0.2s, box-shadow 0.2s;
}

.text-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px #b6e1fb60;
}

.upload-dropzone {
  border: 2.5px dashed var(--primary-color);
  border-radius: 13px;
  background: var(--secondary-color);
  cursor: pointer;
  /* padding: 28px 0 28px 0; */
  text-align: center;
  color: var(--primary-color);
  margin-bottom: 25px;
  transition: background 0.18s, border-color 0.16s;
  user-select: none;
  position: relative;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-dropzone.disabled {
  pointer-events: none;
  opacity: 0.6;
  filter: grayscale(0.13);
  background: #f5f5f7 !important;
}

.upload-dropzone:hover {
  background: var(--secondary-color);
  border-color: var(--primary-color);
}

.cloud-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-bottom: 8px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  /* background-color: ; */
}

.dropzone-instructions {
  font-size: 1.13rem;
  color: #22313a;
  margin-bottom: 10px;
}

.click-link {
  color: var(--primary-color);
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
  margin-left: 4px;
  transition: color 0.16s;
}

.click-link:hover {
  color: var(--primary-color);
}

.file-types {
  color: #8a96a5;
  font-size: 0.88rem;
  margin-top: 2px;
  margin-bottom: 2px;
}

.selected-file {
  font-size: 1rem;
  margin-bottom: 18px;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--secondary-color);
  border-radius: 6px;
  padding: 7px 12px;
  border: 1px solid var(--primary-color);
  position: relative;
}

.cancel-btn {
  position: absolute;
  right: 5px;
  margin-left: 8px;
  background: transparent;
  border: none;
  color: #d61b1b;
  font-size: 1.13rem;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 50%;
  transition: background 0.17s;
  line-height: 1;
}

.cancel-btn:hover {
  background: #ffeaea;
  color: #a80000;
}

.upload-btn {
  padding: 13px 0;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.13rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 2px;
  transition: background 0.14s, box-shadow 0.14s;
  box-shadow: 0 2px 12px 0 #1976d210;
}

.upload-btn:disabled {
  background: var(--secondary-color);
  cursor: not-allowed;
  color: var(--primary-color);
  opacity: 0.77;
}

.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
}

.loading-message {
  font-size: 1.13rem;
  color: var(--primary-color);
  text-align: center;
  font-weight: 600;
}

.horizontal-loader {
  width: 200px;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 22px;
}

.loader-bar {
  height: 100%;
  width: 40%;
  background-color: var(--primary-color);
  animation: slide 1s linear infinite;
  border-radius: 4px;
}

@keyframes slide {
  0% {
    transform: translateX(-100%);
  }

  50% {
    transform: translateX(50%);
  }

  100% {
    transform: translateX(200%);
  }
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: -10px;
  /* margin-left: 15px; */
  margin-bottom: 20px;
}

/* Form field styles */
.form-field {
  width: 100%;
  margin-bottom: 20px;
}

.form-field label {
  color: #8b8888;
  font-family: 'Lato', sans-serif;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field input,
.form-field select {
  width: 100%;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  color: #32393e;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Lato', sans-serif;
}

.error-border {
  border-color: #dc3545 !important;
}

/* Form field styles to match DocumentType.vue */
.form-field-container {
  width: 100%;
  margin-bottom: 20px;
}

.form-field-label {
  color: #8b8888;
  font-family: Archivo;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field-input {
  width: 100%;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: Archivo;
  font-size: 16px;
  color: #32393e;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
}

.form-field-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(22, 72, 99, 0.1);
}

.form-field-input.error-border {
  border-color: #dc3545 !important;
}

.create-new-btn {
  padding: 5px 10px;
  background: var(--primary-color) !important;
  color: white;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.create-new-btn:hover {
  background: #123a52;
}

.primary-btn {
  background: #164863;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: 'Lato', sans-serif;
  transition: background 0.2s;
}

.primary-btn:hover {
  background: #123a52;
}

.completion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
  text-align: center;
}

.completion-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 32px #0001;
  padding: 56px 40px 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 520px;
  margin: 0 auto;
  font-family: 'Archivo', Arial, sans-serif;
}

.success-anim {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1px;
  position: relative;
}

.completion-title-over-icon {
  position: relative;
  top: -18px;
  font-size: 1.55rem;
  font-weight: 700;
  color: #17497c;
  letter-spacing: 0.01em;
  text-align: center;
  background: #fff;
  padding: 6px 20px 4px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px #b6e1fb22;
  display: inline-block;
}

.allset-line {
  font-size: 1.32rem;
  font-weight: bold;
  color: #101010;
  margin-bottom: 10px;
  text-align: center;
}

.completion-line {
  color: #101010;
  font-size: 1.16rem;
  margin-bottom: 6px;
  text-align: center;
}

.bold-jobs {
  font-weight: bold;
  color: #164863;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

.refresh-btn {
  background: #164863;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  min-width: 36px;
  height: 36px;
}

.refresh-btn:hover:not(:disabled) {
  background: #123a52;
}

.refresh-btn:disabled {
  background: #b6d7f3;
  cursor: not-allowed;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 700px) {
  .completion-card {
    padding: 18px 8px;
    width: 96vw;
  }

  .completion-title-over-icon {
    font-size: 1.1rem;
    padding: 4px 10px 4px 10px;
  }

  .allset-line {
    font-size: 1rem;
  }

  .completion-line {
    font-size: 1rem;
  }
}

.createUserHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  /* border-bottom: 1px solid #e0e0e0; */
  padding-bottom: 9px;
}

.newPageTitle {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
}
</style>
